
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[slug]",
      function () {
        return require("private-next-pages/account/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/[slug]"])
      });
    }
  